import { render, staticRenderFns } from "./Product_detail.vue?vue&type=template&id=0d7c8b34&scoped=true&"
import script from "./Product_detail.vue?vue&type=script&lang=js&"
export * from "./Product_detail.vue?vue&type=script&lang=js&"
import style0 from "./Product_detail.vue?vue&type=style&index=0&id=0d7c8b34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7c8b34",
  null
  
)

export default component.exports